import React, { useEffect, useState } from 'react';
import './CSSToolFiltersManagerTool.css';

const ManagerFilters = ({ triggerProjectReporter, tagsList }) => {
    const [cardCount, setCardCount] = useState(0);
    const [tagCount, setTagCount] = useState(0);
    const [checkedTags, setCheckedTags] = useState({});
    const [cardIDRange, setCardIDRange] = useState({ min: null, max: null });
    const [cardRowRange, setCardRowRange] = useState({ min: null, max: null });
    const [filterRowRangeDisplayNoneApplied, setFilterRowRangeDisplayNoneApplied] = useState([]);
    const [visibleRowRangeText, setVisibleRowRangeText] = useState("None");
    const [filterByIDFromAppliedTagsDisplayNoneApplied, setFilterByIDFromAppliedTagsDisplayNoneApplied] = useState([]);
    const [visibleTaggedCardsText, setVisibleTaggedCardsText] = useState("All Cards");

    const handleTagCheckChange = (tagId) => {
        setCheckedTags(prev => ({
            ...prev,
            [tagId]: !prev[tagId]
        }));
    };

    const projectReporter = () => {
        console.log("projectReporter was called from parent BootstrapStarterBody.jsx");

        // Scan DOM for all instances of div with class "cardSpacer"
        const cardSpacerElements = document.querySelectorAll('div.cardSpacer');
        const count = cardSpacerElements.length;

        // Update the card count state
        setCardCount(count);

        // Scan DOM for the specific tag element
        const tagElement = document.getElementById('appHeaderBarColRight-BoxLogoMenu2of5ButtonBoxImageIconOverlayContainerText');
        let tagCountValue = 0;

        if (tagElement) {
            const displayText = tagElement.textContent || tagElement.innerText || '';
            const integerMatch = displayText.match(/\d+/);
            if (integerMatch) {
                tagCountValue = parseInt(integerMatch[0], 10);
            }
        }

        // Update the tag count state
        setTagCount(tagCountValue);

        // Scan for Card ID range
        const cardIDs = [];
        cardSpacerElements.forEach(cardSpacer => {
            const cardIDElement = cardSpacer.querySelector('#cardOptionsTextContainerCardID');
            if (cardIDElement) {
                const displayText = cardIDElement.textContent || cardIDElement.innerText || '';
                const idMatch = displayText.match(/Card ID:\s*(\d+)/);
                if (idMatch) {
                    cardIDs.push(parseInt(idMatch[1], 10));
                }
            }
        });

        // Find min and max Card IDs
        if (cardIDs.length > 0) {
            const minID = Math.min(...cardIDs);
            const maxID = Math.max(...cardIDs);
            setCardIDRange({ min: minID, max: maxID });
        } else {
            setCardIDRange({ min: null, max: null });
        }

        // Scan for Card Row range
        const cardRows = [];
        cardSpacerElements.forEach(cardSpacer => {
            const cardRowElement = cardSpacer.querySelector('#cardOptionsTextContainerRowLocation');
            if (cardRowElement) {
                const displayText = cardRowElement.textContent || cardRowElement.innerText || '';
                const rowMatch = displayText.match(/Row:\s*(\d+)/);
                if (rowMatch) {
                    cardRows.push(parseInt(rowMatch[1], 10));
                }
            }
        });

        // Find min and max Card Rows
        if (cardRows.length > 0) {
            const minRow = Math.min(...cardRows);
            const maxRow = Math.max(...cardRows);
            setCardRowRange({ min: minRow, max: maxRow });
        } else {
            setCardRowRange({ min: null, max: null });
        }

        // Request tag list from parent (this will be handled by the parent)
        // The parent will update the tagsList prop
    };

    useEffect(() => {
        if (triggerProjectReporter > 0) {
            projectReporter();
        }
    }, [triggerProjectReporter]);

    const [filterIDRangeDisplayNoneApplied, setFilterIDRangeDisplayNoneApplied] = useState([]);
    const [visibleIDRangeText, setVisibleIDRangeText] = useState("None");

    const filterIDRange = () => {
        const minID = cardIDRange.min;
        const maxID = cardIDRange.max;

        if (minID == null || maxID == null) {
            console.log("filterIDRange: ID range is not set properly.");
            return;
        }

        const outOfRangeIDs = [];
        const hiddenCardIDs = [];

        const cardSpacerElements = document.querySelectorAll('div.cardSpacer');
        cardSpacerElements.forEach((cardSpacer, index) => {
            const cardIDElement = cardSpacer.querySelector('#cardOptionsTextContainerCardID');
            if (cardIDElement) {
                const displayText = cardIDElement.textContent || cardIDElement.innerText || '';
                const idMatch = displayText.match(/Card ID:\s*(\d+)/);
                if (idMatch) {
                    const id = parseInt(idMatch[1], 10);
                    if (id < minID || id > maxID) {
                        outOfRangeIDs.push(id);
                        if (index === 0) {
                            // Special treatment for first cardSpacer
                            cardSpacer.style.position = 'absolute';
                            cardSpacer.style.background = 'green';
                            cardSpacer.style.visibility = 'hidden';

                            // Make toolSavedStylesContainerPosition and all its children visible
                            const toolContainer = cardSpacer.querySelector('#toolSavedStylesContainerPosition');
                            if (toolContainer) {
                                toolContainer.style.visibility = 'visible';
                                const allChildren = toolContainer.querySelectorAll('*');
                                allChildren.forEach(child => {
                                    child.style.visibility = 'visible';
                                });
                            }
                        } else {
                            cardSpacer.style.display = 'none';
                        }
                        hiddenCardIDs.push(id);
                    } else {
                        if (index === 0) {
                            // Reset first cardSpacer if it was hidden
                            cardSpacer.style.position = '';
                            cardSpacer.style.background = '';
                            cardSpacer.style.visibility = '';

                            // Reset toolSavedStylesContainerPosition and its children
                            const toolContainer = cardSpacer.querySelector('#toolSavedStylesContainerPosition');
                            if (toolContainer) {
                                toolContainer.style.visibility = '';
                                const allChildren = toolContainer.querySelectorAll('*');
                                allChildren.forEach(child => {
                                    child.style.visibility = '';
                                });
                            }
                        }
                        cardSpacer.style.display = 'flex';
                    }
                }
            }
        });

        if (outOfRangeIDs.length > 0) {
            console.log("filterIDRange found cards outside ID range:", outOfRangeIDs.join(', '));
        } else {
            console.log("filterIDRange: All card IDs are within the selected range.");
        }

        setFilterIDRangeDisplayNoneApplied(hiddenCardIDs);
        if (hiddenCardIDs.length > 0) {
            console.log("filterIDRangeDisplayNoneApplied:", hiddenCardIDs.join(', '));
        }

        setVisibleIDRangeText(`${minID} to ${maxID}`);
    };

    const clearFilterIDRange = () => {
        const cardSpacerElements = document.querySelectorAll('div.cardSpacer');
        const resetIDs = [];

        cardSpacerElements.forEach((cardSpacer, index) => {
            const cardIDElement = cardSpacer.querySelector('#cardOptionsTextContainerCardID');
            if (cardIDElement) {
                const displayText = cardIDElement.textContent || cardIDElement.innerText || '';
                const idMatch = displayText.match(/Card ID:\s*(\d+)/);
                if (idMatch) {
                    const id = parseInt(idMatch[1], 10);
                    if (filterIDRangeDisplayNoneApplied.includes(id)) {
                        if (index === 0) {
                            // Reset first cardSpacer special styling
                            cardSpacer.style.position = '';
                            cardSpacer.style.background = '';
                            cardSpacer.style.visibility = '';

                            // Reset toolSavedStylesContainerPosition and its children
                            const toolContainer = cardSpacer.querySelector('#toolSavedStylesContainerPosition');
                            if (toolContainer) {
                                toolContainer.style.visibility = '';
                                const allChildren = toolContainer.querySelectorAll('*');
                                allChildren.forEach(child => {
                                    child.style.visibility = '';
                                });
                            }
                        }
                        cardSpacer.style.display = 'flex';
                        resetIDs.push(id);
                    }
                }
            }
        });

        console.log("clearFilterIDRange reapplied display:flex to card IDs:", resetIDs.join(', '));
        setFilterIDRangeDisplayNoneApplied([]);

        // Scan the DOM again to get full visible range
        const allCardIDs = [];
        document.querySelectorAll('div.cardSpacer').forEach(cardSpacer => {
            const cardIDElement = cardSpacer.querySelector('#cardOptionsTextContainerCardID');
            if (cardIDElement) {
                const text = cardIDElement.textContent || cardIDElement.innerText || '';
                const match = text.match(/Card ID:\s*(\d+)/);
                if (match) {
                    allCardIDs.push(parseInt(match[1], 10));
                }
            }
        });

        if (allCardIDs.length > 0) {
            const min = Math.min(...allCardIDs);
            const max = Math.max(...allCardIDs);
            setVisibleIDRangeText(`${min} to ${max}`);
        } else {
            setVisibleIDRangeText("None");
        }
    };

    const filterRowRange = () => {
        const minRow = cardRowRange.min;
        const maxRow = cardRowRange.max;

        if (minRow == null || maxRow == null) {
            console.log("filterRowRange: Row range is not set properly.");
            return;
        }

        const outOfRangeRows = [];
        const hiddenCardRows = [];

        const cardSpacerElements = document.querySelectorAll('div.cardSpacer');
        cardSpacerElements.forEach((cardSpacer, index) => {
            const cardRowElement = cardSpacer.querySelector('#cardOptionsTextContainerRowLocation');
            if (cardRowElement) {
                const displayText = cardRowElement.textContent || cardRowElement.innerText || '';
                const rowMatch = displayText.match(/Row:\s*(\d+)/);
                if (rowMatch) {
                    const row = parseInt(rowMatch[1], 10);
                    if (row < minRow || row > maxRow) {
                        outOfRangeRows.push(row);
                        if (index === 0) {
                            // Special treatment for first cardSpacer
                            cardSpacer.style.position = 'absolute';
                            cardSpacer.style.background = 'green';
                            cardSpacer.style.visibility = 'hidden';

                            // Make toolSavedStylesContainerPosition and all its children visible
                            const toolContainer = cardSpacer.querySelector('#toolSavedStylesContainerPosition');
                            if (toolContainer) {
                                toolContainer.style.visibility = 'visible';
                                const allChildren = toolContainer.querySelectorAll('*');
                                allChildren.forEach(child => {
                                    child.style.visibility = 'visible';
                                });
                            }
                        } else {
                            cardSpacer.style.display = 'none';
                        }
                        hiddenCardRows.push(row);
                    } else {
                        if (index === 0) {
                            // Reset first cardSpacer if it was hidden
                            cardSpacer.style.position = '';
                            cardSpacer.style.background = '';
                            cardSpacer.style.visibility = '';

                            // Reset toolSavedStylesContainerPosition and its children
                            const toolContainer = cardSpacer.querySelector('#toolSavedStylesContainerPosition');
                            if (toolContainer) {
                                toolContainer.style.visibility = '';
                                const allChildren = toolContainer.querySelectorAll('*');
                                allChildren.forEach(child => {
                                    child.style.visibility = '';
                                });
                            }
                        }
                        cardSpacer.style.display = 'flex';
                    }
                }
            }
        });

        if (outOfRangeRows.length > 0) {
            console.log("filterRowRange found cards outside Row range:", outOfRangeRows.join(', '));
        } else {
            console.log("filterRowRange: All card Rows are within the selected range.");
        }

        setFilterRowRangeDisplayNoneApplied(hiddenCardRows);
        if (hiddenCardRows.length > 0) {
            console.log("filterRowRangeDisplayNoneApplied:", hiddenCardRows.join(', '));
        }

        setVisibleRowRangeText(`${minRow} to ${maxRow}`);
    };

    const clearFilterRowRange = () => {
        const cardSpacerElements = document.querySelectorAll('div.cardSpacer');
        const resetRows = [];

        cardSpacerElements.forEach((cardSpacer, index) => {
            const cardRowElement = cardSpacer.querySelector('#cardOptionsTextContainerRowLocation');
            if (cardRowElement) {
                const displayText = cardRowElement.textContent || cardRowElement.innerText || '';
                const rowMatch = displayText.match(/Row:\s*(\d+)/);
                if (rowMatch) {
                    const row = parseInt(rowMatch[1], 10);
                    if (filterRowRangeDisplayNoneApplied.includes(row)) {
                        if (index === 0) {
                            // Reset first cardSpacer special styling
                            cardSpacer.style.position = '';
                            cardSpacer.style.background = '';
                            cardSpacer.style.visibility = '';

                            // Reset toolSavedStylesContainerPosition and its children
                            const toolContainer = cardSpacer.querySelector('#toolSavedStylesContainerPosition');
                            if (toolContainer) {
                                toolContainer.style.visibility = '';
                                const allChildren = toolContainer.querySelectorAll('*');
                                allChildren.forEach(child => {
                                    child.style.visibility = '';
                                });
                            }
                        }
                        cardSpacer.style.display = 'flex';
                        resetRows.push(row);
                    }
                }
            }
        });

        console.log("clearFilterRowRange reapplied display:flex to card Rows:", resetRows.join(', '));
        setFilterRowRangeDisplayNoneApplied([]);

        // Scan the DOM again to get full visible range
        const allCardRows = [];
        document.querySelectorAll('div.cardSpacer').forEach(cardSpacer => {
            const cardRowElement = cardSpacer.querySelector('#cardOptionsTextContainerRowLocation');
            if (cardRowElement) {
                const text = cardRowElement.textContent || cardRowElement.innerText || '';
                const match = text.match(/Row:\s*(\d+)/);
                if (match) {
                    allCardRows.push(parseInt(match[1], 10));
                }
            }
        });

        if (allCardRows.length > 0) {
            const min = Math.min(...allCardRows);
            const max = Math.max(...allCardRows);
            setVisibleRowRangeText(`${min} to ${max}`);
        } else {
            setVisibleRowRangeText("None");
        }
    };

    useEffect(() => {
        projectReporter();
    }, []);

    useEffect(() => {
        if (cardIDRange.min !== null && cardIDRange.max !== null) {
            setVisibleIDRangeText(`${cardIDRange.min} to ${cardIDRange.max}`);
        }
    }, [cardIDRange]);

    useEffect(() => {
        if (cardRowRange.min !== null && cardRowRange.max !== null) {
            setVisibleRowRangeText(`${cardRowRange.min} to ${cardRowRange.max}`);
        }
    }, [cardRowRange]);

    const filterTagsApplied = () => {
        const checkedTagTexts = [];

        // Get all checked tag texts
        tagsList.forEach(tag => {
            if (checkedTags[tag.id]) {
                checkedTagTexts.push(tag.text);
            }
        });

        if (checkedTagTexts.length === 0) {
            console.log("filterTagsApplied: No tags are checked.");
            return;
        }

        const matchedCardIDs = [];
        const hiddenCardIDs = [];

        const cardSpacerElements = document.querySelectorAll('div.cardSpacer');
        cardSpacerElements.forEach((cardSpacer, index) => {
            // Get Card ID for this cardSpacer
            const cardIDElement = cardSpacer.querySelector('#cardOptionsTextContainerCardID');
            let cardID = null;
            if (cardIDElement) {
                const displayText = cardIDElement.textContent || cardIDElement.innerText || '';
                const idMatch = displayText.match(/Card ID:\s*(\d+)/);
                if (idMatch) {
                    cardID = parseInt(idMatch[1], 10);
                }
            }

            // Look for applied tags in this card
            const appliedTagElements = cardSpacer.querySelectorAll('ul.appliedTagsDisplayContainerList li.appliedTagsDisplayContainerListItems p');
            const cardTagTexts = [];

            appliedTagElements.forEach(pElement => {
                const tagText = pElement.textContent || pElement.innerText || '';
                if (tagText.trim()) {
                    cardTagTexts.push(tagText.trim());
                }
            });

            // Check if any of the card's tags match the checked tags
            const hasMatchingTag = cardTagTexts.some(cardTagText =>
                checkedTagTexts.includes(cardTagText)
            );

            if (hasMatchingTag) {
                if (index === 0) {
                    // Reset first cardSpacer if it was hidden
                    cardSpacer.style.position = '';
                    cardSpacer.style.background = '';
                    cardSpacer.style.visibility = '';

                    // Reset toolSavedStylesContainerPosition and its children
                    const toolContainer = cardSpacer.querySelector('#toolSavedStylesContainerPosition');
                    if (toolContainer) {
                        toolContainer.style.visibility = '';
                        const allChildren = toolContainer.querySelectorAll('*');
                        allChildren.forEach(child => {
                            child.style.visibility = '';
                        });
                    }
                }
                cardSpacer.style.display = 'flex';
                if (cardID !== null) {
                    matchedCardIDs.push(cardID);
                }
            } else {
                if (index === 0) {
                    // Special treatment for first cardSpacer
                    cardSpacer.style.position = 'absolute';
                    cardSpacer.style.background = 'green';
                    cardSpacer.style.visibility = 'hidden';

                    // Make toolSavedStylesContainerPosition and all its children visible
                    const toolContainer = cardSpacer.querySelector('#toolSavedStylesContainerPosition');
                    if (toolContainer) {
                        toolContainer.style.visibility = 'visible';
                        const allChildren = toolContainer.querySelectorAll('*');
                        allChildren.forEach(child => {
                            child.style.visibility = 'visible';
                        });
                    }
                } else {
                    cardSpacer.style.display = 'none';
                }
                if (cardID !== null) {
                    hiddenCardIDs.push(cardID);
                }
            }
        });

        console.log("filterTagsApplied matched card IDs:", matchedCardIDs.join(', '));
        console.log("filterTagsApplied hidden card IDs:", hiddenCardIDs.join(', '));

        setFilterByIDFromAppliedTagsDisplayNoneApplied(hiddenCardIDs);

        // Updated logic for displaying visible card IDs
        if (matchedCardIDs.length > 0) {
            // Sort the IDs numerically for better display
            const sortedIDs = matchedCardIDs.sort((a, b) => a - b);
            setVisibleTaggedCardsText(`${sortedIDs.join(', ')}`);
        } else {
            setVisibleTaggedCardsText("No matching cards");
        }
    };

    const clearFilterTags = () => {
        const cardSpacerElements = document.querySelectorAll('div.cardSpacer');
        const resetIDs = [];

        cardSpacerElements.forEach((cardSpacer, index) => {
            const cardIDElement = cardSpacer.querySelector('#cardOptionsTextContainerCardID');
            if (cardIDElement) {
                const displayText = cardIDElement.textContent || cardIDElement.innerText || '';
                const idMatch = displayText.match(/Card ID:\s*(\d+)/);
                if (idMatch) {
                    const id = parseInt(idMatch[1], 10);
                    if (filterByIDFromAppliedTagsDisplayNoneApplied.includes(id)) {
                        if (index === 0) {
                            // Reset first cardSpacer special styling
                            cardSpacer.style.position = '';
                            cardSpacer.style.background = '';
                            cardSpacer.style.visibility = '';

                            // Reset toolSavedStylesContainerPosition and its children
                            const toolContainer = cardSpacer.querySelector('#toolSavedStylesContainerPosition');
                            if (toolContainer) {
                                toolContainer.style.visibility = '';
                                const allChildren = toolContainer.querySelectorAll('*');
                                allChildren.forEach(child => {
                                    child.style.visibility = '';
                                });
                            }
                        }
                        cardSpacer.style.display = 'flex';
                        resetIDs.push(id);
                    }
                }
            }
        });

        console.log("clearFilterTags reapplied display:flex to card IDs:", resetIDs.join(', '));
        setFilterByIDFromAppliedTagsDisplayNoneApplied([]);
        setVisibleTaggedCardsText("None");
    };

    const applyAllFilters = () => {
        filterIDRange();
        setTimeout(() => {
            filterRowRange();
            setTimeout(() => {
                filterTagsApplied();
            }, 150);
        }, 150);
    };

    const clearAllFilters = () => {
        clearFilterIDRange();
        setTimeout(() => {
            clearFilterRowRange();
            setTimeout(() => {
                clearFilterTags();
            }, 150);
        }, 150);
    };


    return (
        <div>
            <div>
                <div className="sectionTitle">Project Report:</div>
                <div >{cardCount} Card{cardCount !== 1 ? 's' : ''}</div>
                <div >{tagCount} Tag{tagCount !== 1 ? 's' : ''}</div>
                <div className="sectionTitle">
                    <div className="sectionTitle"><button className="buttonFilterTool buttonFilterToolUpdate" onClick={projectReporter}>UPDATE Report</button></div>



                    <div className="sectionTitle"><button className="buttonFilterTool buttonFilterToolApply" onClick={applyAllFilters}>APPLY ALL Filters</button></div>
                    <div className="sectionTitle"><button className="buttonFilterTool buttonFilterToolClear" onClick={clearAllFilters}>CLEAR ALL Filters</button></div>
                </div>
            </div>

            <div className="filterToolContainer">
                <div id="filterByID">
                    <div className="sectionTitle">Filter Cards by ID Range</div>
                    <div>
                        ID:&nbsp;
                        <input type="number" value={cardIDRange.min || 0}
                            onChange={(e) => setCardIDRange(prev => ({ ...prev, min: parseInt(e.target.value) || 0 }))}
                            style={{ width: '4ch', display: 'inline' }}
                        >
                        </input>&nbsp;
                        to ID:&nbsp;
                        <input type="number"
                            value={cardIDRange.max || 0}
                            onChange={(e) => setCardIDRange(prev => ({ ...prev, max: parseInt(e.target.value) || 0 }))}
                            style={{ width: '4ch', display: 'inline' }}
                        >
                        </input>
                    </div>
                    <div className="sectionTitle">
                        <button className="buttonFilterTool buttonFilterToolApply" onClick={filterIDRange}>APPLY ID Range Filter</button>
                    </div>
                    <div className="filterAppliedReport">ID Range View: {visibleIDRangeText}</div>
                    <div className="sectionTitle">
                        <button className="buttonFilterTool buttonFilterToolClear" onClick={clearFilterIDRange}>CLEAR ID Range Filter</button>
                    </div>

                </div>
            </div>

            <div className="filterToolContainer">
                <div id="filterByRow">
                    <div className="sectionTitle">Filter Cards by Row Range</div>
                    <div>
                        Row:&nbsp;
                        <input type="number" value={cardRowRange.min || 0}
                            onChange={(e) => setCardRowRange(prev => ({ ...prev, min: parseInt(e.target.value) || 0 }))}
                            style={{ width: '4ch', display: 'inline' }}
                        >
                        </input>&nbsp;
                        to Row:&nbsp;
                        <input type="number"
                            value={cardRowRange.max || 0}
                            onChange={(e) => setCardRowRange(prev => ({ ...prev, max: parseInt(e.target.value) || 0 }))}
                            style={{ width: '4ch', display: 'inline' }}
                        >
                        </input>
                    </div>
                    <div className="sectionTitle"><button className="buttonFilterTool buttonFilterToolApply" onClick={filterRowRange}>APPLY Row Range Filter</button></div>
                    <div className="filterAppliedReport">Row Range View: {visibleRowRangeText}</div>
                    <div className="sectionTitle"><button className="buttonFilterTool buttonFilterToolClear" onClick={clearFilterRowRange}>CLEAR Row Range Filter</button></div>
                </div>
            </div>

            <div className="filterToolContainer">
                <div id="filterByTag">
                    <div className="sectionTitle">Filter Cards by Tag</div>
                    <ol>
                        {tagsList && tagsList.map(tag => (
                            <li key={tag.id} style={{ width: '90%', display: 'list-item', marginBottom: '5px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ width: '80%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                        {tag.text}
                                    </span>
                                    <input
                                        type="checkbox"
                                        id={`tag-${tag.id}`}
                                        checked={checkedTags[tag.id] || false}
                                        onChange={() => handleTagCheckChange(tag.id)}
                                        style={{ marginLeft: 'auto' }}
                                    />
                                </div>
                            </li>
                        ))}
                    </ol>

                    <div className="sectionTitle"><button className="buttonFilterTool buttonFilterToolApply" onClick={filterTagsApplied}>APPLY Tag Filter</button></div>
                    <div className="filterAppliedReport">Tagged Cards View: {visibleTaggedCardsText}</div>
                    <div className="sectionTitle"><button className="buttonFilterTool buttonFilterToolClear" onClick={clearFilterTags}>CLEAR Tag Filter</button></div>
                </div>

            </div>
        </div>
    )
}

export default ManagerFilters